import _get from 'lodash/get';
const GM_CERT_MAKES = ['BUICK', 'CADILLAC', 'CHEV', 'GMC'];

// This helper method is used to determine the productId to use in certifiedSponsor.json / wordpress cpo endpoint
export default function getProductId(certifiedProduct, makeCode) {
  const productId = _get(certifiedProduct, 'id', '');
  if (productId === 'GM_CERT' && GM_CERT_MAKES.includes(makeCode)) {
    return `${makeCode}_CERT`;
  }
  return productId;
}